import { 
    FETCH_NEWS,
    FETCH_NEW,
    RESET_NEWS
} from "./NewConst";

/* Search actions */
export const fetchNews = (dispatch,params) => dispatch({type: FETCH_NEWS, params})
export const fetchNew  = (dispatch,params) => dispatch({type: FETCH_NEW, params})
export const resetNews = (dispatch,params) => dispatch({type: RESET_NEWS, params})